(() => {
  const active = new Map();
  const root = () => window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    // Compatible timeout; do not require AbortSignal.timeout on older browsers.
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root() + path, {
        signal: controller.signal,
        method: body ? 'POST' : 'GET',
        cache: 'no-store',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your basket. Please try again.');
      return data;
    } finally {
      clearTimeout(timer);
    }
  };
  const linesFor = (cart, id) => cart.items.filter(item => item.properties?._lavoir_bundle === id);
  const removeBundle = async (cart, id) => {
    let lines = linesFor(cart, id);
    const parents = lines.filter(item => !item.parent_relationship);
    const updates = Object.fromEntries((parents.length ? parents : lines).map(item => [item.key, 0]));
    cart = await request('cart/update.js', { updates });
    lines = linesFor(cart, id);
    if (lines.length) cart = await request('cart/update.js', { updates: Object.fromEntries(lines.map(item => [item.key, 0])) });
    if (linesFor(cart, id).length) throw new Error('Please review your basket before trying again.');
    return cart;
  };
  const perform = async ({ items, bundleId, towelVariantId, expectedTowelPrice, sections = [], copy = {} }) => {
    if (!bundleId || !items?.length) throw new Error(copy.error || 'Unable to add this selection.');
    const payload = items.map(item => ({ ...item, properties: { ...item.properties, _lavoir_bundle: bundleId } }));
    const expected = new Map();
    payload.forEach(item => expected.set(String(item.id), (expected.get(String(item.id)) || 0) + item.quantity));
    let cart = await request('cart.js');
    let lines = linesFor(cart, bundleId);
    let addedSections;
    if (!lines.length) {
      try {
        const result = await request('cart/add.js', { items: payload, ...(sections.length ? { sections, sections_url: window.location.pathname } : {}) });
        addedSections = result.sections;
      } catch (error) {
        cart = await request('cart.js');
        if (!linesFor(cart, bundleId).length) { error.bundleRemoved = true; throw error; }
      }
      cart = await request('cart.js');
      lines = linesFor(cart, bundleId);
    }
    const actual = new Map();
    lines.forEach(item => actual.set(String(item.variant_id), (actual.get(String(item.variant_id)) || 0) + item.quantity));
    const complete = actual.size === expected.size && [...expected].every(([id, quantity]) => actual.get(id) === quantity);
    const towels = towelVariantId ? lines.filter(item => String(item.variant_id) === String(towelVariantId)) : [];
    const tolerance = cart.currency === 'GBP' ? 0 : 1;
    const priced = !towelVariantId || (towels.length && towels.every(item => item.final_line_price <= (expectedTowelPrice + tolerance) * item.quantity));
    const towelSaving = towels.reduce((sum, item) => sum + Math.max(0, item.original_line_price - expectedTowelPrice * item.quantity), 0);
    const twoTinSaving = cart.items.filter(item => item.handle === 'la-lessive-liquid-laundry-soap').reduce((sum, item) => sum + (item.line_level_discount_allocations || []).filter(discount => discount.discount_application?.title === 'Two Bottles — 10% Off').reduce((amount, discount) => amount + discount.amount, 0), 0);
    const betterTinOffer = towels.length > 0 && towelSaving > 0 && twoTinSaving >= towelSaving;
    if (!complete || (!priced && !betterTinOffer)) {
      const error = new Error(!priced ? (copy.pricing || 'The tea towel offer could not be applied. Please try again or contact us.') : (copy.incomplete || 'Your selection could not be added in full. Please try again.'));
      try { await removeBundle(cart, bundleId); error.bundleRemoved = true; } catch { error.message += ' Please review your basket before trying again.'; }
      throw error;
    }
    return { cart, sections: addedSections };
  };
  window.LavoirBatchThree = {
    addBundle(options) {
      if (active.has(options.bundleId)) return active.get(options.bundleId);
      const promise = perform(options).finally(() => active.delete(options.bundleId));
      active.set(options.bundleId, promise);
      return promise;
    }
  };
  const initialise = scope => scope.querySelectorAll('[data-lavoir-towel]').forEach(input => {
    input.disabled = input.dataset.available !== 'true';
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-lavoir-towel]')) return;
    const offer = event.target.closest('[data-lavoir-offer]');
    const panel = offer.querySelector('[data-lavoir-personalisation]');
    panel.hidden = !event.target.checked;
    panel.querySelector('input').disabled = !event.target.checked;
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-lavoir-towel-initials]')) event.target.value = event.target.value.replace(/[^\p{L}]/gu, '').toUpperCase().slice(0, 4);
  });
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node instanceof Element) initialise(node);
  }))).observe(document.documentElement, { childList: true, subtree: true });
})();
